import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
import { formatNumber } from "../../libraries/helper";
 
export default () => {

  const moduleName = "wholesales";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.wholesales_destroy, location.search]);

  useEffect(() => {
    if (appReducer.wholesales_list != undefined) {
      setRows(appReducer.wholesales_list.data)
      setTotalPages(appReducer.wholesales_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'تعداد در هر کارتون',
      selector: row => row.numbers,
    },
    {
      name: 'نوع',
      selector: row => `${row.product_price.product.name} - ${row.product_price.name} - ${row.product_price.code}`,
    },
    {
      name: 'قیمت پایه',
      selector: row => `${formatNumber(row.price)} تومان`,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages}  columns={columns} data={rows} />;

};
